import React from 'react';
import { Grid, Table, Segment, Button, Icon, Modal, Form, Dropdown, Label } from 'semantic-ui-react';
import { Helmet } from 'react-helmet';
import { Link, withRouter } from 'react-router-dom';
import moment from 'moment';

const DetailsOfCohort = ({
  loading,
  history,
  cohortDetails,
  cohortUserDetails,
  cohortVendingMachines,
  onDeleteOfUser,
  onDeleteOfVM,
  onClickOfAddUserToCohort,
  onClickOfAddVMToCohort,
  addVMModal,
  onSaveOfVMMapping,
  onSelectionOfVendingMachines,
  addUserModal,
  onCloseOfAddVMModal,
  onCloseOfAddUserModal,
  onSelectionOfUsers,
  onSaveOfUserMapping
}) => {
  if (loading) {
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <Segment style={{ height: '90vh' }} loading={loading} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
  return (
    <Grid centered padded style={{ marginTop: '0px', padding: '10vh' }}>
      <Helmet>
        <title> Cohort Details </title>
      </Helmet>
      <Grid.Row centered>
        <Grid.Column width={4}>
          <h2
            style={{
              fontWeight: 400,
              border: '1px solid #555',
              textAlign: 'center',
              color: '#555',
              padding: '0.5em'
            }}
          >
            Cohort Details
          </h2>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row centered>
        <Grid.Column width={14} textAlign="center">
          <Button
            floated="left"
            basic
            color="green"
            onClick={() => history.push('/vendingmachines/cohorts/list')}
          >
            <Icon name="ordered list" />
            Back to List
          </Button>
          <Button
            floated="right"
            icon
            labelPosition="left"
            basic
            color="blue"
            size="small"
            onClick={() => history.push('/vendingmachines/cohorts/new')}
          >
            <Icon name="globe" /> Create New Cohort
          </Button>
          <Label
            as="a"
            href="#vmdetails"
            basic
            size="large"
            style={{ float: 'right' }}
          >
            Add Vending Machine
          </Label>
          <Label
            as="a"
            href="#userdetails"
            basic
            size="large"
            style={{ float: 'right' }}
          >
            Add User
          </Label>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={8} textAlign="center">
          <Modal
            size="small"
            open={addVMModal.showAddVMToCohortModal}
            closeIcon
            onClose={onCloseOfAddVMModal}
          >
            {addVMModal.showAddVMToCohortModal && addVMModal.loadingVMList ? (
              <Grid>
                <Grid.Row>
                  <Grid.Column>
                    <Segment style={{ height: '30vh' }} loading={addVMModal.loadingVMList} />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            ) : (
              <React.Fragment>
                <Modal.Header>Add Vending Machine to : {`"${cohortDetails.name}"`}</Modal.Header>
                <Modal.Content>
                  <Grid.Row centered>
                    <Grid.Column width={6}>
                      <Form>
                        <Form.Field required>
                          <label>Select Vending Machine</label>
                          <Dropdown
                            disabled={addVMModal.loadingVMList || addVMModal.savingVMMappping}
                            onChange={onSelectionOfVendingMachines}
                            selection
                            multiple
                            search
                            options={addVMModal.vmList}
                          />
                        </Form.Field>
                      </Form>
                    </Grid.Column>
                  </Grid.Row>
                </Modal.Content>
                <Modal.Actions>
                  <Button
                    icon
                    labelPosition="left"
                    basic
                    color="red"
                    size="small"
                    onClick={onCloseOfAddVMModal}
                  >
                    <Icon name="cancel" /> Cancel
                  </Button>
                  <Button
                    icon
                    labelPosition="left"
                    basic
                    color="blue"
                    size="small"
                    onClick={onSaveOfVMMapping}
                  >
                    <Icon name="save" /> Save
                  </Button>
                </Modal.Actions>
              </React.Fragment>
            )}
          </Modal>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={14} textAlign="center">
          <Modal
            size="small"
            open={addUserModal.showAddUserToCohortModal}
            closeIcon
            onClose={onCloseOfAddUserModal}
          >
            {addUserModal.showAddUserToCohortModal && addUserModal.loadingUserList ? (
              <Grid>
                <Grid.Row>
                  <Grid.Column>
                    <Segment style={{ height: '30vh' }} loading={addUserModal.loadingUserList} />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            ) : (
              <React.Fragment>
                <Modal.Header>Add User(s) to : {`"${cohortDetails.name}"`}</Modal.Header>
                <Modal.Content>
                  <Grid.Row centered>
                    <Grid.Column width={6}>
                      <Form>
                        <Form.Field required>
                          <label>Select Users</label>
                          <Dropdown
                            disabled={
                              addUserModal.loadingUserList || addUserModal.savingUserMappping
                            }
                            onChange={onSelectionOfUsers}
                            selection
                            multiple
                            search
                            options={addUserModal.userList}
                          />
                        </Form.Field>
                      </Form>
                    </Grid.Column>
                  </Grid.Row>
                </Modal.Content>
                <Modal.Actions>
                  <Button
                    icon
                    labelPosition="left"
                    basic
                    color="red"
                    size="small"
                    onClick={onCloseOfAddUserModal}
                  >
                    <Icon name="cancel" /> Cancel
                  </Button>
                  <Button
                    icon
                    labelPosition="left"
                    basic
                    color="blue"
                    size="small"
                    onClick={onSaveOfUserMapping}
                  >
                    <Icon name="save" /> Save
                  </Button>
                </Modal.Actions>
              </React.Fragment>
            )}
          </Modal>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={8}>
          <React.Fragment>
            <h3 style={{ fontWeight: 400, textDecoration: 'underline' }}>Details of Cohort</h3>
            <Table definition>
              <Table.Header>
                <Table.Row />
              </Table.Header>
              <Table.Body>
                <Table.Row>
                  <Table.Cell>Cohort Id</Table.Cell>
                  <Table.Cell>{cohortDetails.id}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Cohort Name</Table.Cell>
                  <Table.Cell>{cohortDetails.name}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Cohort Area</Table.Cell>
                  <Table.Cell>{cohortDetails.area_name}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Cohort Description</Table.Cell>
                  <Table.Cell>{cohortDetails.description || 'N/A'}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Cohort Latitude</Table.Cell>
                  <Table.Cell>{cohortDetails.lat || 'N/A'}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Cohort Longitude</Table.Cell>
                  <Table.Cell>{cohortDetails.lng || 'N/A'}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Created On</Table.Cell>
                  <Table.Cell>
                    {moment
                      .utc(cohortDetails.created_at)
                      .local()
                      .format('DD-MM-YYYY HH:mm:ss')}
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Creator Mobile</Table.Cell>
                  <Table.Cell>{cohortDetails.created_by_user_mobile}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Creator Name</Table.Cell>
                  <Table.Cell>{cohortDetails.created_by_user_name}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>Creator Role</Table.Cell>
                  <Table.Cell>{cohortDetails.created_by_user_role}</Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </React.Fragment>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row centered >
        <Grid.Column width={14} >
          <React.Fragment >
            <h3 id="vmdetails" style={{ fontWeight: 400, textDecoration: 'underline', paddingTop: '8vh' }}>
              Vending Machine Details
            </h3>
            <Grid.Row centered>
              <Grid.Column width={14} textAlign="center">
                <Button
                  floated="right"
                  icon
                  labelPosition="left"
                  basic
                  color="blue"
                  size="small"
                  onClick={onClickOfAddVMToCohort}
                >
                  <Icon name="building outline" /> Add New Vending Machine
                </Button>
                <Label
                  as="a"
                  href="#userdetails"
                  basic
                  size="large"
                  style={{ float: 'right' }}
                >
                Want to Add User ?
                </Label>
              </Grid.Column>
            </Grid.Row>
            <br />
            <br />
            <Table celled fixed>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>VM Id</Table.HeaderCell>
                  <Table.HeaderCell>Name</Table.HeaderCell>
                  <Table.HeaderCell>Street</Table.HeaderCell>
                  <Table.HeaderCell>City</Table.HeaderCell>
                  <Table.HeaderCell>State</Table.HeaderCell>
                  <Table.HeaderCell>Assigned On</Table.HeaderCell>
                  <Table.HeaderCell>Assigned By User Mobile</Table.HeaderCell>
                  <Table.HeaderCell>Assigned By User Name</Table.HeaderCell>
                  <Table.HeaderCell>Actions</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {cohortVendingMachines &&
                  cohortVendingMachines.length &&
                  cohortVendingMachines.map(el => (
                    <Table.Row>
                      <Table.Cell>{el.id}</Table.Cell>
                      <Table.Cell>
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <Link
                          to={`/vendingmachines/${el.id}/details`}
                          style={{
                            textDecoration: 'underline',
                            color: '#603cba',
                            wordWrap: 'break-word'
                          }}
                        >
                          {el.name}
                        </Link>
                      </Table.Cell>
                      <Table.Cell>{el.street}</Table.Cell>
                      <Table.Cell>{el.city}</Table.Cell>
                      <Table.Cell>{el.state || 'N/A'}</Table.Cell>
                      <Table.Cell style={{ wordWrap: 'break-word' }}>
                        {/* {new Date(el.created_at).toLocaleString()} */}
                        {moment
                          .utc(el.assigned_on)
                          .local()
                          .format('DD-MM-YYYY HH:mm:ss')}
                      </Table.Cell>
                      <Table.Cell>{el.assigned_by_user_mobile}</Table.Cell>
                      <Table.Cell>{el.assigned_by_user_name || 'N/A'}</Table.Cell>
                      <Table.Cell>
                        <Button
                          onClick={() => onDeleteOfVM(el.id, el.vending_machine_cohort_id)}
                          basic
                          color="red"
                          size="tiny"
                        >
                          Remove
                        </Button>
                      </Table.Cell>
                    </Table.Row>
                  ))}
              </Table.Body>
            </Table>
          </React.Fragment>
          <React.Fragment>
            <h3 id="userdetails" style={{ fontWeight: 400, textDecoration: 'underline', paddingTop: '8vh' }}>User Details</h3>
            <Grid.Row centered>
              <Grid.Column width={14} textAlign="center">
                <Button
                  floated="right"
                  icon
                  labelPosition="left"
                  basic
                  color="blue"
                  size="small"
                  onClick={onClickOfAddUserToCohort}
                >
                  <Icon name="user" /> Add New User
                </Button>
                <Label
                  as="a"
                  href="#vmdetails"
                  basic
                  size="large"
                  style={{ float: 'right' }}
                >
                Want to Add Vending Machine?
                </Label>
              </Grid.Column>
            </Grid.Row>
            <br />
            <br />
            <Table celled fixed>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>User Id</Table.HeaderCell>
                  <Table.HeaderCell>Mobile</Table.HeaderCell>
                  <Table.HeaderCell>Name</Table.HeaderCell>
                  <Table.HeaderCell>Email Id</Table.HeaderCell>
                  <Table.HeaderCell>User Role</Table.HeaderCell>
                  <Table.HeaderCell>Assigned On</Table.HeaderCell>
                  <Table.HeaderCell>Assigned By User Mobile</Table.HeaderCell>
                  <Table.HeaderCell>Assigned By User Name</Table.HeaderCell>
                  <Table.HeaderCell>Actions</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {cohortUserDetails &&
                  cohortUserDetails.length &&
                  cohortUserDetails.map(el => (
                    <Table.Row>
                      <Table.Cell>{el.id}</Table.Cell>
                      <Table.Cell>{el.mobile}</Table.Cell>
                      <Table.Cell>{el.full_name || 'N/A'}</Table.Cell>
                      <Table.Cell>{el.email || 'N/A'}</Table.Cell>
                      <Table.Cell
                        style={{
                          wordWrap: 'break-word'
                        }}
                      >
                        {el.user_role}
                      </Table.Cell>
                      <Table.Cell style={{ wordWrap: 'break-word' }}>
                        {/* {new Date(el.created_at).toLocaleString()} */}
                        {moment
                          .utc(el.assigned_on)
                          .local()
                          .format('DD-MM-YYYY HH:mm:ss')}
                      </Table.Cell>
                      <Table.Cell>{el.assigned_by_user_mobile}</Table.Cell>
                      <Table.Cell>{el.assigned_by_user_name}</Table.Cell>
                      <Table.Cell>
                        <Button
                          onClick={() =>
                            onDeleteOfUser(el.full_name, el.id, el.vending_machine_cohort_id)
                          }
                          basic
                          color="red"
                          size="tiny"
                        >
                          Remove
                        </Button>
                      </Table.Cell>
                    </Table.Row>
                  ))}
              </Table.Body>
            </Table>
            <br />
            <br />
          </React.Fragment>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default withRouter(DetailsOfCohort);



// WEBPACK FOOTER //
// ./src/Modules/VMCohortDetails/component.jsx